import { computed } from 'vue';
import { createI18n, useI18n } from 'vue-i18n';
import zhCN from './locale/zh-CN';
import enUS from './locale/en-US';

const i18n = createI18n({
	legacy: false,
	// 'zh-CN' : 'en-US'
	locale: 'zh-CN',
	fallbackLocale: 'en-US',
	messages: {
		'zh-CN': zhCN,
		'en-US': enUS,
	},
});
export default i18n;

export function useLocale(localeMap: Record<string, Record<string, string>>) {
	const { locale } = useI18n();
	const message = computed(() => (localeMap && localeMap[locale.value]) || {});

	const exchangeLocale = () => {
		// storage.set(S_I18N_LOCALE, locale.value === 'zh-CN' ? 'en-US' : 'zh-CN');
		setTimeout(() => location.reload(), 200);
	};

	return {
		message,
		locale,
		exchangeLocale,
	};
}
